import imageSource from "./fatsecret.png"
import styles from "./FatsecretImage.module.scss"
export function FatsecretImage() {
  return (
    <img
      src={imageSource}
      className={styles.fatsecret}
      alt="Fatsecret"
    />
  )
}
